import React, { Component } from 'react';

import moment from 'moment';
import AvailableOn from './Component/AvailableOn';
import LocationOption from '../../../_components/Options/LocationOption'
import ReactDatePicker from '../../../_components/DatePicker/ReactDatePicker'
import ProfessionalOption from '../../../_components/Options/ProfessionalOption';
import PreVisitQuestionOption from '../../../_components/Options/PreVisitQuestionOption';

import "react-datepicker/dist/react-datepicker.css";

const CURRENT_STEP = 'TELEHEALTH_REAL_TIME_DETAILS';

class TelehealthRealTimeDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
    }

    this.validate = this.validate.bind(this);
  }

  validate(e) {
    e.preventDefault();

    let errors = {};

    if (!this.props.appointmentDate) {
      errors.dateTime = 'Appointment Date is required.'
    } else if (moment(this.props.appointmentDate).isBefore(new Date())) {
      errors.dateTime = 'Appointment Date must be upcoming.';
    }

    if (!this.props.groupId) {
      errors.group = 'Location is required.'
    }

    if (!this.props.providerId) {
      errors.provider = 'Provider is required.'
    }

    if (!this.props.preVisitQuestionId) {
      errors.questions = 'Pre-visit Questions are required.'
    }

    if (this.props.availableOn && moment(this.props.availableOn).isSameOrBefore(moment())) {
      errors.availableOn = 'Available On must be an upcoming date.';
    }

    if (this.props.availableOn && moment(this.props.availableOn).hours() < 6) {
      errors.availableOn = 'Available On must be after 6:00 AM';
    }

    if (this.props.availableOn && moment(this.props.availableOn).hours() > 22) {
      errors.availableOn = 'Available On must be before 10:00 PM';
    }

    if (this.props.availableOn && this.props.appointmentDate && moment(this.props.availableOn).isSameOrAfter(moment(this.props.appointmentDate))) {
      errors.availableOn = 'Available On must be before appointment date.';
    }

    this.setState({ errors });

    if (!errors.dateTime && !errors.provider && !errors.group && !errors.questions && !errors.availableOn) {
      this.props.scheduleTelehealth();
    }
  }

  renderValidateMessage(field) {
    const message = this.state.errors[field];

    return (
      <div id={`${field}-error`} className="text-danger hide">{message}</div>
    );
  }

  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    const {
      groupId,
      setValue,
      isSaving,
      providerId,
      availableOn,
      appointmentDate,
      preVisitQuestionId
    } = this.props;

    return (
      <div className="card axs-shadow">
        <div className="card-body">
          <h3 className="d-inline font-weight-bold">Schedule Telehealth Appointment</h3>&nbsp;
          <h6 className="ml-3 d-inline font-weight-bold text-muted">Telehealth Details</h6>
          <hr />

          <form className="mt-4">
            <div className="form-row pb-4">
              <div className="form-group col-sm-4">
                <label><span className="text-danger">*</span> Provider</label>
                <ProfessionalOption defaultValue={providerId} handleSelected={(value) => setValue('providerId', value)} />
                {this.renderValidateMessage('provider')}
              </div>
              <div className="form-group col-sm-4">
                <label><span className="text-danger">*</span> Location</label>
                <LocationOption defaultValue={groupId} handleSelected={(value) => setValue('groupId', value)} />
                {this.renderValidateMessage('group')}
              </div>
              <div className="form-group col-sm-4">
                <label><span className="text-danger">*</span> Pre-visit Questions</label>
                <PreVisitQuestionOption defaultValue={preVisitQuestionId} handleSelected={(value) => setValue('preVisitQuestionId', value)} />
                {this.renderValidateMessage('questions')}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-sm-4">
                <label><span className="text-danger">*</span> Appointment Date</label>
                <ReactDatePicker
                  selected={appointmentDate}
                  onChange={date => setValue('appointmentDate', date)}
                  minDate={new Date()}
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={5}
                  dateFormat="MMM d, yyyy h:mm aa"
                  className="form-control"
                  wrapperClassName="w-100"
                />
                {this.renderValidateMessage('dateTime')}
              </div>

              <div className="form-group col-sm-4">
                <AvailableOn
                  sendOn={availableOn}
                  setAvailableOn={(date) => setValue('availableOn', date)}
                  apptDate={appointmentDate}
                  apptType="telehealth" />
                {this.renderValidateMessage('availableOn')}
              </div>
            </div>
          </form>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-sm-2">
              <button
                disabled={isSaving}
                onClick={this.props.backStep}
                type="submit" className="btn btn-outline-primary btn-block">Back</button>
            </div>
            <div className="col-sm-4">
              <button
                onClick={this.validate}
                disabled={isSaving}
                type="submit" className="btn btn-primary btn-block">
                {isSaving ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Schedule Telehealth'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TelehealthRealTimeDetails;